import { cloneElement, isValidElement, ReactNode } from 'react'

import {
  Tooltip as UiKitTooltip,
  TooltipProps as UiKitTooltipProps,
  useTooltip,
} from '@revolut-internal/ui-kit'

type AnchorProps = ReturnType<ReturnType<typeof useTooltip>['getAnchorProps']>

export type TooltipProps = Omit<UiKitTooltipProps, 'children' | 'anchorRef'> & {
  delay?: number
  disabled?: boolean
  open?: boolean
  defaultOpen?: boolean
  message?: UiKitTooltipProps['children']
  onToggle?: (value: boolean) => void
  children: ReactNode | ((props: AnchorProps) => ReactNode)
}

export const Tooltip = ({
  delay,
  disabled,
  open,
  defaultOpen,
  message,
  onToggle,
  children,
  ...rest
}: TooltipProps) => {
  const { getAnchorProps, getTargetProps } = useTooltip({
    delay,
    disabled,
    state: open,
    defaultState: defaultOpen,
    onChange: onToggle,
  })

  let child: ReactNode
  if (typeof children === 'function') {
    child = children(getAnchorProps())
  } else if (isValidElement(children)) {
    child = cloneElement(children, getAnchorProps())
  } else {
    child = <span {...getAnchorProps()}>{children}</span>
  }

  return (
    <>
      {child}
      {Boolean(message) && (
        <UiKitTooltip {...getTargetProps(rest)}>{message}</UiKitTooltip>
      )}
    </>
  )
}
